import React, { useState } from "react";
import MsbNameField from "./MsbNameField";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import DeviceTypeField from "./DeviceTypeField";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { getMsbByNameIfExists, updateMsb } from "../../../ruleService";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function EditMsbModal({ selectedMsb, setShowModal, validationErrors }) {

    let deviceTypeId = -1;
    if (selectedMsb.deviceType) {
        deviceTypeId = selectedMsb.deviceType.id;
    }
    const [msb, setMsb] = useState(selectedMsb);
    const [deviceType, setDeviceType] = useState(String(deviceTypeId));

    const onSaveClick = async () => {
        if (deviceType === '-1' || !deviceType) {
            showDangerToast(`Device Type does not exist`, "Save MSB");
            return;
        }

        let serverMsb;
        try {
            serverMsb = await getMsbByNameIfExists(msb.name);
        } catch (error) {
            showDangerToast(error.message || "Unable to check MSB name", "Save MSB");
            return;
        }

        let updatedMsb;

        if (serverMsb && serverMsb.id !== msb.id) {
            showDangerToast(`MSB with name '${msb.name}' already exist`, "Save MSB");
            return;
        }

        try {
            updatedMsb = await updateMsb(msb, deviceType);
        } catch (error) {
            return;
        }

        if (updatedMsb) {
            showSuccessToast("MSB updated", "Edit MSB");
            setShowModal(false);
        }
    }

    return (
        <TargetTypeWizardModal
            title="Edit MSB Wizard"
            subtitle="Update the selected MSB details."
            onClose={() => setShowModal(false)}
            onSubmit={onSaveClick}
            submitLabel="Update"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--stack"
        >
            <DeviceTypeField deviceType={deviceType} setDeviceType={setDeviceType} />
            <MsbNameField msb={msb} setMsb={setMsb} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(EditMsbModal);

